import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.75 2.414L2.414 14.75l.876.876a3.631 3.631 0 0 1 1.835-.501 3.758 3.758 0 0 1 3.75 3.75c0 .7-.156 1.34-.466 1.87l.841.84L21.586 9.25l-.841-.84c-.53.309-1.17.465-1.87.465a3.758 3.758 0 0 1-3.75-3.75c0-.7.156-1.34.466-1.87l-.841-.84zm0-1.414l2.2 2.2c-.55.412-.825 1.1-.825 1.925a2.758 2.758 0 0 0 2.75 2.75c.825 0 1.512-.275 1.925-.825l2.2 2.2L9.25 23l-2.2-2.2c.55-.413.825-1.1.825-1.925a2.758 2.758 0 0 0-2.75-2.75c-.688 0-1.375.275-1.925.825L1 14.75 14.75 1z"
});

var SvgTicket = function SvgTicket(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgTicket;